import { LoadingSpinner } from '@momentum-ui/react-collaboration';
import { useEffect } from 'react';
import { webexExchangeToken } from '../ms-teams-sdk/service/MsTeamsAuthenticationService';
import './Auth.scss';

/**
 *
 */
export const WebexAuthPage = () => {
  useEffect(() => {
    webexExchangeToken();
  }, []);

  return (
    <div className="authorization-page">
      <LoadingSpinner scale={64} />
    </div>
  );
};